var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.generalTableData)?_c('ChangeLogTable',{attrs:{"data":_vm.limitedData,"filterOptions":_vm.filterOptions},on:{"filterTypeChange":_vm.filterTypeChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }